<template>
    <div class="headerWrap">
        <div class="up">
            <div class="wrap text">
                <ul class="navigation">
                    <li>
                        <router-link :to="{path:'/'}">
                            <i class="home"></i>
                            首页
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="down">
            <div class="wrap option">
                <h1 >
                    <img width="260px"  src="../assets/images/LOGO.png" style="margin-top: 20px;">
                </h1>
                <ul class="choose">
                    <li>
                        <router-link :to="{path:'/'}">
                            <i class="home"></i>
                            首页
                        </router-link>
                    </li>
                    <li>
                        <router-link :to="{path:'/about'}" class="tab_color">
                            <i class="home"></i>
                            关于景初
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

    <script>
import { getUserInfo, removeItem } from "@/common/utils/localStorage.js";
export default {
    name: "Header",
    data() {
        return {
            userInfo: getUserInfo(),
            shopCarNum: 0,
            levelList: [],
            isCollapse:false,
        };
    },
    components: {},
    watch: {
        $route() {
            this.getBreadcrumb();
        },
    },
    computed: {
    },
    created() {
    },
    mounted() {
        // let userInfo = getUserInfo();
        // if (userInfo.token) {
        //     this.$store.state.DataStorage.LoginShowOrNot = false;
        //     this.getShopCarData();
        // }
    },
    destroyed() {},
    watch: {},
    methods: {
    },
};
</script>

<style scoped lang="scss">
.headerWrap {
    .up {
        height: 40px;
        line-height: 40px;
        background-color: rgb(31, 43, 64);
        .navigation {
            float: right;
            color: #fff;
            li {
                margin: 0 20px;
                float: left;
                a {
                    color: #fff;
                }
            }
        }
    }
    .down {
        width: 100%;
        height: 110px;
        background: #fff;
        .option {
            height: 110px;
            h1 {
                float: left;
                a {
                    display: block;
                    width: 188px;
                    height: 58px;
                    // background: url(../images/logo.png);
                    text-indent: -9999em;
                    overflow: hidden;
                    margin-top: 26px;
                }
            }
            .choose {
                // float: right;
                li {
                    // float: left;
                    a {
                        float: left;
                        height: 110px;
                        padding: 0 28px;
                        text-align: right;
                        border-left: 1px solid #fff;
                        border-right: 1px solid #fff;
                        line-height: 110px;
                        font-size: 16px;
                        color: #333;
                        // position: relative;
                    }
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Header.vue